import config from '../config'
import { authorizedFetch }  from '../utils/auth.js'
import { checkStatus } from '../utils/fetch'
import { logOut } from '../actions/users'

export const SHOW_ADD_SESSION_FORM = 'SHOW_ADD_SESSION_FORM'
export const CLOSE_ADD_SESSION_FORM = 'CLOSE_ADD_SESSION_FORM'
export const UPDATE_SESSION_FIELD = 'UPDATE_SESSION_FIELD'
export const UPDATE_SESSION = 'UPDATE_SESSION'
export const UPDATE_SESSION_SUCCEDED = 'UPDATE_SESSION_SUCCEDED'
export const DELETE_SESSION = 'DELETE_SESSION'
export const DELETE_SESSION_SUCCEDED = 'DELETE_SESSION_SUCCEDED'
export const SHOW_SESSION_ERROR = 'SHOW_SESSION_ERROR'

export const displayError = (error) => ({
  type: SHOW_SESSION_ERROR,
  error: error
})

export const showUpdateSessionForm = (session) => ({
  type: SHOW_ADD_SESSION_FORM,
  session: session
})

export const closeAddSessionForm = () => ({
  type: CLOSE_ADD_SESSION_FORM,
})

export const updateSessionField = (name, value) => ({
  type: UPDATE_SESSION_FIELD,
  name: name,
  value: value
})

export const updateSession = (session) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'sessions/update',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({session: session})
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateSessionSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const updateSessionSucceded = (session) => ({
  type: UPDATE_SESSION_SUCCEDED,
  session: session
})

export const deleteSession = (session) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'sessions/delete',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ session : session })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(deleteSessionSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const deleteSessionSucceded = (session) => ({
  type: DELETE_SESSION_SUCCEDED,
  session: session
})



// WEBPACK FOOTER //
// ./src/actions/sessions.js